// src/components/Login/ResetPasswordForm.tsx
import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resetPassword } from '../../api/userService';
import logo from '../../assets/damelio_logo_negro.png';
import logo2 from '../../assets/damelio_texto_negro.png';

const ResetPasswordForm: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  // Obtenemos el token de la URL
  const token = searchParams.get('token');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!token) {
      setError(t('resetPassword.errors.noToken'));
      return;
    }

    if (password !== confirmPassword) {
      setError(t('resetPassword.errors.passwordsDontMatch'));
      return;
    }

    try {
      // Llamamos al endpoint para resetear la contraseña
      const response = await resetPassword(token, password);
      if (response.error) {
        throw new Error(response.error);
      }
      setMessage(t('resetPassword.successMessage'));
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err: any) {
      console.error(err);
      setError(t('resetPassword.errors.general'));
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-sm w-full bg-white p-6 rounded shadow space-y-6">
        {/* Logos */}
        <div
          className="text-center cursor-pointer group transition-transform duration-300"
          onClick={() => navigate('/')}
        >
          <img
            src={logo}
            alt={t('login.altLogo')}
            className="mx-auto h-32 w-auto transition-transform duration-300"
          />
          <img
            src={logo2}
            alt={t('login.altLogo2')}
            className="mx-auto h-16 w-auto mt-2 transition-transform duration-300"
          />
        </div>

        {/* Título */}
        <h2 className="text-center text-2xl font-bold">
          {t('resetPassword.title')}
        </h2>

        {/* Formulario */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              {t('resetPassword.labels.newPassword')}
            </label>
            <input
              type="password"
              id="password"
              className="block w-full mt-1 p-2 border border-gray-300 rounded-md"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('resetPassword.placeholders.newPassword')}
              required
            />
          </div>
          <div>
            <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
              {t('resetPassword.labels.confirmPassword')}
            </label>
            <input
              type="password"
              id="confirmPassword"
              className="block w-full mt-1 p-2 border border-gray-300 rounded-md"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder={t('resetPassword.placeholders.confirmPassword')}
              required
            />
          </div>
          <button
            type="submit"
            className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded shadow"
          >
            {t('resetPassword.buttons.resetPassword')}
          </button>
        </form>

        {/* Mensajes de error o éxito */}
        {error && <p className="text-center text-red-500 text-sm">{error}</p>}
        {message && <p className="text-center text-green-500 text-sm">{message}</p>}
      </div>
    </div>
  );
};

export default ResetPasswordForm;
